module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmSU5fBBc-.b00849e0.b00849e0.woff";